import { CharterAllBoatsList } from 'types/fleet';

export default function filterByIds(boats: CharterAllBoatsList, ids: string[]) {
  if (!ids.length) {
    return [];
  }

  return boats.filter((boat) => ids.includes(boat.id));
}
